import snackBowlIcon from '../../../assets/icons/mulnyang/snack-bowl.png';

export default function CatRunningSnackShortageModal({
  open = false,
  snackCount = 0,
  loading = false,
  onClose,
  onCharge,
  secondaryLabel = '닫기',
}) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[300] flex min-h-[100dvh] w-screen items-center justify-center bg-[rgba(0,0,0,0.58)] p-6 backdrop-blur-[12px]"
      role="dialog"
      aria-modal="true"
      aria-label="간식 부족 팝업"
    >
      <div className="relative z-[1] w-full max-w-[320px] rounded-[16px] bg-[linear-gradient(180deg,#dfd7ff_0%,#ffffff_85%)] px-[10px] pb-[10px] pt-[30px] text-center shadow-[0_5px_16px_rgba(0,0,0,0.1)]">
        <button
          type="button"
          className="absolute right-4 top-4 inline-flex h-6 w-6 items-center justify-center border-0 bg-transparent p-0 text-[34px] font-light leading-[20px] text-[#333]"
          aria-label="팝업 닫기"
          onClick={onClose}
          disabled={loading}
        >
          ×
        </button>
        <img src={snackBowlIcon} alt="" className="mx-auto block h-[63px] w-[70px] object-contain" />
        <h3 className="m-0 mt-5 font-['Pretendard'] text-[22px] font-extrabold leading-[1.4] tracking-[0.44px] text-[#333]">
          간식 부족
        </h3>
        <p className="m-0 mt-2 font-['Pretendard'] text-[14px] font-bold leading-[1.4] tracking-[0.28px] text-[#8b68dd]">
          {`보유간식 : ${Number(snackCount).toLocaleString()}개`}
        </p>
        <p className="m-0 mt-[5px] font-['Pretendard'] text-[14px] font-bold leading-[1.4] tracking-[0.28px] text-[#5e5e5e]">
          <span className="text-[#f6475f]">간식 1개</span>가 부족해요
        </p>
        <button
          type="button"
          className="mt-[30px] flex h-[52px] w-full items-center justify-center rounded-[8px] border-0 bg-[#1e1e1e] font-['Pretendard'] text-[16px] font-bold leading-[1.4] tracking-[-0.3px] text-white disabled:cursor-not-allowed disabled:bg-[#d9d9d9] disabled:text-[#8a8a8a]"
          onClick={onCharge}
          disabled={loading}
        >
          {loading ? '광고 준비 중' : '광고 보고 간식 받기'}
        </button>
        <button
          type="button"
          className="mt-[10px] h-[52px] w-full rounded-[8px] border-0 bg-[#f4f4f4] font-['Pretendard'] text-[16px] font-bold leading-[1.4] tracking-[-0.3px] text-[#919191] disabled:cursor-not-allowed disabled:bg-[#d9d9d9] disabled:text-[#8a8a8a]"
          onClick={onClose}
          disabled={loading}
        >
          {secondaryLabel}
        </button>
      </div>
    </div>
  );
}
